import { FormGroup, Validators } from '@angular/forms';

export interface Result {
  total: number;
  msg: string;
  status: string;
  data: [];
}


export class BaseComponent {
  validateForm: FormGroup;
  Result: Result;
  constructor() {
    this.Result = {
      total: 0,
      msg: '',
      status: '',
      data: [] // 这里可以根据实际需要初始化数据
    };
  }

  // 表单必要性更新
  setRequired(name: string, desc: string): void {
    if (
      this.validateForm.get(name).value === '' &&
      this.validateForm.get(desc).value === ''
    ) {
      this.validateForm.controls[name].clearValidators();
      this.validateForm.controls[desc].clearValidators();
    } else {
      this.validateForm.get(name)!.setValidators(Validators.required);
      this.validateForm.get(desc)!.setValidators(Validators.required);
    }
  }

  getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  // 下载base64格式
  downloadFile(fileName, fileType, content) {
    let blob = this.base64ToBlob(content, fileType); // new Blob([content]);
    const nav = (window.navigator as any);
    if (nav.msSaveOrOpenBlob) {
      // ie
      nav.msSaveOrOpenBlob(blob, fileName);
    } else {
      // 只支持firefox,chrome
      let aLink = document.createElement('a');
      // let blob = this.base64ToBlob(content, fileType); //new Blob([content]);
      let evt = document.createEvent('HTMLEvents');
      evt.initEvent('click', true, true); // initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
    }
  }

  // base64转blob
  base64ToBlob(code, fileType) {
    // let parts = code.split(';base64,');
    // let contentType = parts[0].split(':')[1];
    let raw = window.atob(code);
    let rawLength = raw.length;
    let uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: fileType });
  }

  // 判断是否是IE浏览器
  detectIE() {
    const ua = window.navigator.userAgent;

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  }

  // 下载流格式
  downloadFile6(blob, fileName) {
    // 获取response headers数据
    // const name = blob.headers("Content-Disposition");
    const nav = (window.navigator as any);
    if (nav.msSaveOrOpenBlob) {
      // ie
      nav.msSaveOrOpenBlob(blob, fileName);
    } else {
      // 只支持firefox,chrome
      let aLink = document.createElement('a');
      // let blob = this.base64ToBlob(content, fileType); //new Blob([content]);
      let evt = document.createEvent('HTMLEvents');
      evt.initEvent('click', true, true); // initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
    }
  }
  // 下载流格式
  downloadFile8(blob, fileName) {
    // 获取response headers数据
    // const name = blob.headers("Content-Disposition");
    const nav = (window.navigator as any);
    if (nav.msSaveOrOpenBlob) {
      // ie
      nav.msSaveOrOpenBlob(blob, fileName);
    } else {
      // 只支持firefox,chrome
      let aLink = document.createElement('a');
      // let blob = this.base64ToBlob(content, fileType); //new Blob([content]);
      let evt = document.createEvent('HTMLEvents');
      evt.initEvent('click', true, true); // initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
    }
  }

  // 通过链接下载
  downloadFileByUrl(url, name): void {
    let aLink = document.createElement('a');
    // let blob = this.base64ToBlob(content, fileType); //new Blob([content]);
    let evt = document.createEvent('HTMLEvents');
    evt.initEvent('click', true, true); // initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
    aLink.download = name;
    aLink.href = url;
    document.body.appendChild(aLink);
    aLink.click();
    document.body.removeChild(aLink);
  }

  saveByteArray(fileName: string, byteArray: Uint8Array, fileType?: string) {
    const blob = new Blob([byteArray], { type: fileType });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  base64ToUint8Array(base64: string): Uint8Array {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }

  // 获取年月日时分秒--拼接:20200318175723
  getTimeString(): string {
    const date = new Date();
    let year = date.getFullYear();
    let month =
      date.getMonth() + 1 > 9
        ? date.getMonth() + 1
        : '0' + (date.getMonth() + 1);
    let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
    let hour = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
    let minute =
      date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
    let second =
      date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();

    return `${year}${month}${day}${hour}${minute}${second}`;
  }

  // 获取特定时间的年月日格式--拼接:2020/2/11
  getTheDateString(date): string {
    var d = new Date(date);
    var resDate = `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
    return resDate;
  }

  // 获取特定时间的年月日格式--拼接:2020/06/01
  getTheDateString_(date): string {
    if (date) {
      var d = new Date(date);
      var monthStr =
        d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
      var dayStr = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
      var resDate = `${d.getFullYear()}-${monthStr}-${dayStr}`;
      return resDate;
    }
  }

    // 转换为UTC+8时间
  getUTC8DateString(date: Date): string {
    if (!date) return ''; // 如果日期为空，返回空字符串
    const utc8Time = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Shanghai' })); // 转换为 UTC+8 时间
    return this.getTheDateString_(utc8Time); // 调用现有的格式化函数
  }


  // 获取前12个月时间的年月日格式--拼接:2020-2-11
  getTheDateStringforReason12M(): string {
    const date = new Date();
    var d = new Date(date);
    var resDate = `${d.getFullYear() - 1}-${d.getMonth() + 1}-${d.getDate()}`;
    return resDate;
  }

  // 获取当前时间的年月日格式--拼接:2020-2-11
  getTheDateStringforReason(): string {
    const date = new Date();
    var d = new Date(date);
    var resDate = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
    return resDate;
  }

  // 获取当前时间的年月日格式--拼接:2020-02-11
  getTheDateStringforMMDD(): string {
    const date = new Date();
    var d = new Date(date);
    var monthStr =
      d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
    var dayStr = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
    var resDate = `${d.getFullYear()}-${monthStr}-${dayStr}`;
    return resDate;
  }
  // 获取特定时间的年月日格式--拼接:2020/06
  getTheDateString_YM(date): string {
    if (date) {
      var d = new Date(date);
      var monthStr =
        d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
      var resDate = `${d.getFullYear()}-${monthStr}`;
      return resDate;
    }
  }

  formatString(str: string, ...val: string[]) {
    for (let index = 0; index < val.length; index++) {
      str = str.replace(`{${index}}`, val[index]);
    }
    return str;
  }

}
